import { render, staticRenderFns } from "./ayNav.vue?vue&type=template&id=47fbd2ec&"
import script from "./ayNav.vue?vue&type=script&lang=js&"
export * from "./ayNav.vue?vue&type=script&lang=js&"
import style0 from "./ayNav.vue?vue&type=style&index=0&id=47fbd2ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports